import React, { useEffect, useState } from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { roomColumns } from "./RoomStatusData";
import api from "../../../../../../api/axios";

const RoomStatusTable = () => {
  const [roomData, setRoomData] = useState([]);
  const [loading, setLoading] = useState(true);

  // ▶ STATUS BADGE COLOR LOGIC
  const getStatusColor = (status) => {
    switch (status) {
      case "occupied":
        return "text-bg-warning";
      case "dirty":
        return "text-bg-danger";
      case "maintenance":
      case "out_of_order":
        return "text-bg-secondary";
      default:
        return "text-bg-success"; // vacant
    }
  };

  // ▶ FETCH ROOMS FROM API
  const fetchRooms = async () => {
    try {
      const response = await api.get("/pms/rooms");

      setRoomData(response.data || []);
    } catch (error) {
      console.error("Error fetching rooms:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  // ▶ MAP UI DATA
  const dataT = roomData.map((room) => ({
    roomNumber: room.room_number,
    roomType: room.room_type.name ?? "-",
    bedType: room.bed_type ?? "-",
    // checkOut: "None", // No checkout field yet
    status: (
      <span className={`badge ${getStatusColor(room.status)}`}>
        {room.status}
      </span>
    ),
  }));


  return (
    <>
      <DataTableHeader />

      {loading ? (
        <p className="text-center py-4">Loading...</p>
      ) : (
        <DataTable columns={roomColumns} data={dataT} />
      )}

      {/* <DataTableFooter dataT={dataT} /> */}
    </>
  );
};

export default RoomStatusTable;
